import React from 'react';
import { Container, Row, Col, Breadcrumb, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { FaArrowLeft } from "react-icons/fa";
import './examHeader.module.css';
import { LinkContainer } from 'react-router-bootstrap';

const ExamHeader = (props) => {

    const { title, cover, price, discount } = props;

    const history = useHistory();

    return (
        <div className="course-header page-header" style={{ backgroundImage: !!cover ? 'url(' + cover + ')' : 'none' }}>
            <Container className="pb-5">
                <Row className="position-relative mb-4">
                    <Col xs={1} className="align-self-center page-back-wrap">
                        <button className="btn btn-link text-white" onClick={() => history.goBack()}><FaArrowLeft /></button>
                    </Col>
                    <Col xs={11}>
                        <Breadcrumb className="breadcumb">
                            <LinkContainer to="/">
                                <Breadcrumb.Item>হোম</Breadcrumb.Item>
                            </LinkContainer>
                            <LinkContainer to="/exams">
                                <Breadcrumb.Item>
                                    ই-এক্সাম সমূহ
                                </Breadcrumb.Item>
                            </LinkContainer>
                            {/* <Breadcrumb.Item active>Data</Breadcrumb.Item> */}
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col className="align-self-center course-header-content" xs={12} md={12}>
                        <Row className="py-3 align-items-center">
                            <Col xs={12} sm={8}>
                                <div className="w-100">
                                    {
                                        !!title && <h2 className="page-title">{title}</h2>
                                    }

                                </div>
                                <div className="w-100">
                                    {
                                        !!props.children && props.children
                                    }
                                </div>
                            </Col>
                            {/* <Col xs={12} sm={8}>
                            </Col> */}
                            <Col xs={12} sm={4}>
                                <div className="d-flex flex-column justify-content-center" styleName="exam-meta">
                                    {/* <span className="text-center" styleName="label">কোর্স ফী</span> */}
                                    <div className="d-flex flex-column justify-content-center align-items-center mb-4" styleName="exam-meta-price">
                                        {price > 0 ? <span className="text-center" styleName="price-new"> {price - discount} টাকা</span> : <span className="text-center" styleName="price-new"> Free</span>}
                                        {discount !== 0 && <span className="text-center line-through price-old">{price} টাকা</span>}
                                    </div>
                                    <Button className="custom-btn-dark btn-lg btn btn-primary">Enroll</Button>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    {/* <Col xs={12} md={5} className="align-self-md-end text-md-right text-center">
                        {
                            !!cover && <Image className="img-fluid page-cover" src={cover} />
                        }
                    </Col> */}
                </Row>
            </Container>
        </div>
    )
}

export default ExamHeader;